import { ChildrenProp } from "../../types/common";
import { FooterContext } from "./FooterContext";
import { useState } from "react";

export function FooterProvider({ children }: ChildrenProp) {
  const [showFooter, setShowFooter] = useState(false);

  return <FooterContext.Provider value={{ showFooter, setShowFooter }}>{children}</FooterContext.Provider>;
}
